import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";
import Select from "react-select";

const RejectVerificationModal = ({
  isOpen,
  toggle,
  onConfirm,
  rejectionOptions,
  adminRemarks,
  setAdminRemarks,
  helpers,
  t,
  isLoading,
  isDeleted
}) => {
  return (
    <Modal 
      isOpen={isOpen} 
      toggle={isLoading ? undefined : toggle} 
      centered 
      backdrop={isLoading ? "static" : true}
      keyboard={!isLoading}
    >
      <ModalHeader toggle={isLoading ? undefined : toggle}>
        {t("page.users.details.denyVerification", "Deny Verification")}
      </ModalHeader>
      <ModalBody>
        <Select
          options={rejectionOptions}
          classNamePrefix="react-select"
          className="mb-2"
          placeholder={t("page.userListings.selectRejectReason", "Select rejection reason")}
          isMulti={true}
          value={helpers.getSelectedOptions(adminRemarks, rejectionOptions)}
          onChange={(options) => {
            const keys = options ? options.map((opt) => opt.value) : [];
            setAdminRemarks(keys);
          }}
          isSearchable={true}
          isDisabled={isDeleted || isLoading}
        />
        <textarea
          className="form-control heading-sm mt-3"
          rows="6"
          placeholder={t("page.users.details.remarksPlaceholder", "Select a reason for the rejection...")}
          value={helpers.getRemarksDisplay(adminRemarks, rejectionOptions)}
          disabled={isDeleted || isLoading}
          readOnly={true}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={isLoading}>
          {t("common.cancel", "Cancel")}
        </Button>
        <Button color="danger" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? <> <Spinner size="sm" /> {t("page.users.details.denyVerification", "Deny Verification")} </> : t("page.users.details.denyVerification", "Deny Verification")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RejectVerificationModal;
